import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import Moment from "moment";
import { createExportAssessment } from "actions/assessments";
import { getUserInfo, getUserSections } from 'actions/user';
import { setPageTitle } from 'actions/header';
import User from "_class/User";
import DateTime from "_class/DateTime";
import { getUserAssessmentDates } from "helpers/user";
import { getActiveSchool } from 'helpers/localstorage';
import swal from 'sweetalert2';
import UserAssessments from './Partials/UserAssessments';
import AttendanceList from "./Partials/AttendanceList";
import DatePickers from "./Partials/DatePickers";
import GroupFilter from "./Partials/GroupFilter";
import MentorVerdicts from "./Partials/MentorVerdicts";
import Schedule from 'containers/Schedule/Schedule';
import MentorNotes from './Partials/MentorNotes';
import AdditionalAdjustments from './Partials/AdditionalAdjustments';
import UserMeetings from './Partials/UserMeetings';
import UserDetails from './Partials/UserDetails';
import UserFileArchive from './Partials/UserFileArchive';
import MentorGoalOverview from './Partials/MentorGoalOverview';
import { Spinner } from "UI";
import { Button, getActiveLanguage, Tabs, Tab } from '@haldor/ui';

var UserProgress = /*#__PURE__*/function (_Component) {
  _inherits(UserProgress, _Component);

  var _super = _createSuper(UserProgress);

  function UserProgress(props) {
    var _this;

    _classCallCheck(this, UserProgress);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_getUserId", function () {
      var userId = null;

      if (_this.props.match != null && _this.props.match.params.userId != null) {
        userId = _this.props.match.params.userId;
      } else if (_this.props.userId != null) {
        userId = _this.props.userId;
      } else {
        userId = _this.props.currentUser.id;
      }

      return userId;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var userId = _this._getUserId();

      _this.props.getUserInfo(userId, 'extended').then(function () {
        var savedUser = _this.props.users.find(function (usr) {
          return usr.id == userId;
        });

        if (savedUser != null) {
          _this.props.setPageTitle(savedUser.firstName + " " + savedUser.lastName);
        }
      });

      _this.props.getUserSections(userId);
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (_ref) {
      var start = _ref.start,
          end = _ref.end;

      if (start == 'Invalid date') {
        start = Moment().subtract(1, 'years');
      }

      if (end == 'Invalid date') {
        end = Moment().add(1, 'years');
      }

      _this.setState({
        start: new DateTime(start).getDateStamp(),
        end: new DateTime(end).getDateStamp()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateDates", function (event) {
      event.preventDefault();
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end;
      localStorage.setItem("assessment-start-date", new DateTime(start).getDateStamp());
      localStorage.setItem("assessment-end-date", new DateTime(end).getDateStamp());

      _this.setState({
        currentStartDate: start,
        currentEndDate: end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupChange", function (groupId) {
      var group = _this.props.userSections.find(function (g_object) {
        return g_object.id == groupId;
      });

      _this.props.userSections.map(function (group) {
        group.open = false;
        group.hidden = false;
      });

      if (group != null) {
        _this.props.userSections.map(function (group) {
          if (groupId != group.id) {
            group.hidden = true;
          }
        });
      } else {
        _this.props.userSections.map(function (group) {
          group.open = false;
          group.hidden = false;
          return group;
        });
      }

      _this.setState({
        selectedGroupId: groupId
      }, function () {
        if (group != null) {
          group.open = true;
          group.hidden = false;
        }

        _this.setState({});
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createAssessmentForStudent", function (userId) {
      swal.fire({
        title: _this.props.translate('export-assessment'),
        text: _this.props.translate('export-assessment-confirm-text'),
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: _this.props.translate('Cancel')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.createExportAssessment(userId);
        }
      });
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      loaded: false,
      selectedGroupId: 0,
      start: getUserAssessmentDates().start,
      end: getUserAssessmentDates().end,
      currentStartDate: getUserAssessmentDates().start,
      currentEndDate: getUserAssessmentDates().end
    };
    return _this;
  }

  _createClass(UserProgress, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userSections = _this$props.userSections,
          translate = _this$props.translate;
      var user = new User(this.props.currentUser);
      var activeSchoolId = getActiveSchool(this.props.currentUser.id);
      var activeSchool = this.props.currentUser.schools.find(function (school) {
        return school.id == activeSchoolId;
      });
      var isStudent = user.isStudent();
      var showTeacherTabs = user.isStudent() || user.isTeacher() || user.isMentor() || user.isAdministrator();
      var userId = null;

      if (this.props.match != null && this.props.match.params.userId != null) {
        userId = this.props.match.params.userId;
      } else if (this.props.userId != null) {
        userId = this.props.userId;
      } else {
        userId = this.props.currentUser.id;
      }

      var activeUser = this.props.users.find(function (user) {
        return user.userId == userId;
      });

      if (isStudent) {
        if (userId != this.props.currentUser.id) {
          return /*#__PURE__*/React.createElement(Redirect, {
            to: "/404"
          });
        }
      }

      if (this.props.tenant == null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "progress single-task"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form",
        style: {
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement(DatePickers, {
        startDate: this.state.start,
        endDate: this.state.end,
        onChange: this.onDateChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static last"
      }, /*#__PURE__*/React.createElement(GroupFilter, {
        onChange: this.onGroupChange,
        sections: userSections,
        selectedGroupId: this.state.selectedGroupId
      })))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem",
          marginBottom: "1rem"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.updateDates
      }, translate("update")))), /*#__PURE__*/React.createElement(Tabs, null, activeSchool.type != 'PRESCHOOL' && showTeacherTabs ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('assessments-header-overview'),
        route: "assessments"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserAssessments, {
        studentOverView: true,
        studentId: userId,
        start: this.state.currentStartDate,
        end: this.state.currentEndDate,
        sectionId: this.state.selectedGrupId != 0 ? this.state.selectedGroupId : null
      }))) : null, activeSchool.type == 'PRESCHOOL' ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('goals'),
        route: "goals"
      }, /*#__PURE__*/React.createElement(MentorGoalOverview, {
        userId: userId,
        start: this.state.start,
        end: this.state.end
      })) : null, this.props.services.verdicts && activeSchool.type != 'PRESCHOOL' && showTeacherTabs ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('verdicts'),
        route: "verdicts"
      }, /*#__PURE__*/React.createElement(MentorVerdicts, {
        userId: userId,
        start: this.state.currentStartDate,
        end: this.state.currentEndDate,
        isStudent: isStudent,
        user: activeUser
      })) : null, !isStudent && this.props.services.schedule && activeSchool.type != 'PRESCHOOL' ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('schedule'),
        route: "schedule"
      }, /*#__PURE__*/React.createElement(Schedule, {
        redirect: "back",
        studentId: userId,
        overview: true,
        studentCard: true
      })) : null, this.props.services.attendance && activeSchool.type != 'PRESCHOOL' ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('attendance'),
        route: "attendance"
      }, /*#__PURE__*/React.createElement(AttendanceList, {
        start: this.state.start,
        end: this.state.end,
        sectionId: this.state.selectedGroupId,
        user: userId
      })) : null, this.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('additional-adjustments'),
        route: "adjustments"
      }, /*#__PURE__*/React.createElement(AdditionalAdjustments, {
        start: this.state.start,
        end: this.state.end,
        user: userId
      })) : null, this.props.services.notes ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('notes'),
        route: "notes"
      }, /*#__PURE__*/React.createElement(MentorNotes, {
        user: userId,
        isUpdated: this.props.isUpdated,
        isUpdating: this.props.isUpdating,
        isStudent: isStudent
      })) : null, this.props.services.meetings && (user.isMentor() || user.isAdministrator()) ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('meetings'),
        route: "meetings"
      }, /*#__PURE__*/React.createElement(UserMeetings, {
        user: userId,
        start: this.state.start
      })) : null, user.isMentor() ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('documentation'),
        route: "documentation"
      }, /*#__PURE__*/React.createElement(UserFileArchive, {
        user: userId
      })) : null, !isStudent ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('details'),
        route: "details"
      }, /*#__PURE__*/React.createElement(UserDetails, {
        user: userId
      })) : null));
    }
  }]);

  return UserProgress;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    services: state.Services.availableServices,
    userSections: state.user.sections,
    currentUser: state.user.currentUser,
    users: state.user.info
  };
}

export default connect(mapStateToProps, {
  getUserSections: getUserSections,
  getUserInfo: getUserInfo,
  setPageTitle: setPageTitle,
  createExportAssessment: createExportAssessment
})(UserProgress);